import { RankingFieldDTO } from './ranking-field-details.dto';
import { RootState } from '../../../../../../../store/reducers';

export const selectCurrentRankingField = (state: RootState): RankingFieldDTO =>
  state.rankings.rankingFieldProfile.profile;
